import React, { FC } from "react";

import {
  IPortfolio,
  IPortfolioIssueAnswer,
  TKeyValue,
  ISimpleTeachingMaterial,
} from "../../../../state";
import styles from "../PortfolioPreview.module.scss";

type Props = {
  teachingMaterial: ISimpleTeachingMaterial;
  portfolio: IPortfolio;
};

const Retrospective: FC<Props> = ({ teachingMaterial, portfolio }) => {
  const lessons = teachingMaterial.lessons.slice(1, -1);

  const getRetrospectiveAnswer = (index: number) => {
    const lessonIndex = lessons.length === 3 ? index + 1 : index;
    const lessonKey = `lesson0${lessonIndex}_issue_answers`;
    const issueAnswers: IPortfolioIssueAnswer[] = (portfolio as TKeyValue)[
      lessonKey
    ];

    const first = issueAnswers?.find(a => a.order_num === 0)?.content ?? "";
    const second = issueAnswers?.find(a => a.order_num === 1)?.content ?? "";

    return { first, second };
  };

  return (
    <div className={styles.content}>
      <p className={styles.title}>学習の過程（振り返りワーク回答）</p>
      <ul className={styles.list}>
        {lessons.map((lesson, index) => (
          <li key={index} className={styles.item}>
            <div className={styles.heading}>
              <p className={styles.box}>
                <span>{lesson.name}</span>
                <span>{lesson.title}</span>
              </p>
              <p className={styles.keyword}>
                <span>keyword</span>
                <span>{lesson.lesson_keyword?.name}</span>
              </p>
            </div>
            <div className={styles.text}>
              <p className={styles.row}>
                {getRetrospectiveAnswer(index).first}
              </p>
              <p className={styles.row}>
                {getRetrospectiveAnswer(index).second}
              </p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Retrospective;
